import join from "proper-url-join";

import { SEGMENTS } from "@/constants/routes.constants";

export const routes = {
  practitionerScheduling: (practitionerId = ":practitionerId") =>
    join(SEGMENTS.PRACTITIONERS, practitionerId),
  practitionerAvailability: (practitionerId = ":practitionerId") =>
    join(SEGMENTS.PRACTITIONERS, practitionerId, "availability"),
  analyticsDashboard: (id: number | string = ":id") =>
    join(SEGMENTS.ANALYTICS, String(id)),
  clinicPractitioner: (id = ":id") =>
    join(SEGMENTS.CLINIC_CONFIGURATION, SEGMENTS.CLINIC_PRACTITIONERS, id),
  clinicLocation: (id = ":id") =>
    join(SEGMENTS.CLINIC_CONFIGURATION, SEGMENTS.CLINIC_LOCATIONS, id),
  clinicService: (id = ":id") =>
    join(SEGMENTS.CLINIC_CONFIGURATION, SEGMENTS.CLINIC_SERVICES, id),
};
